/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Xml_FeedInputs */

const cs_enum_xml_feed = /** @type {(inputs: Enum_Xml_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML feed`)
};

const en_enum_xml_feed = /** @type {(inputs: Enum_Xml_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML feed`)
};

/**
* | output |
* | --- |
* | "XML feed" |
*
* @param {Enum_Xml_FeedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_xml_feed = /** @type {((inputs?: Enum_Xml_FeedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Xml_FeedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_xml_feed(inputs)
	return cs_enum_xml_feed(inputs)
});